import { FlexContainer } from 'features/common/components/FlexContainer';
import { PriceRowProps } from './types';
import { useAppSelector } from 'store/hooks';
import { RootState } from 'store';

import { Price, Text } from '../OrderSummary.styles';

export const PriceRow = ({ title, price }: PriceRowProps) => {
	const { isPunchup } = useAppSelector(({ auth }: RootState) => auth);
	return (
		<FlexContainer justifyContent="space-between">
			<Text isPunchup={isPunchup}>{title}</Text>
			<Price isPunchup={isPunchup}>${price}</Price>
		</FlexContainer>
	);
};
